import { Highlight } from '@curology/ui-components-web/react/Highlight';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { ModalImage } from '../ModalImage';
import { ModalPricingVolumeAndProductOptionSelector } from '../ModalPricingVolumeAndProductOptionSelector';
import { ModalRatingAndNumReviews } from '../ModalRatingAndNumReviews';

export const EmergencySpotPatchesModalContent = ({
  modalCard,
}: {
  modalCard: Card;
}) => {
  const { modal } = modalCard;

  return (
    <>
      <ModalImage modal={modal} />
      <Typography className="cur-mt-4" size="h2">
        Emergency spot patches
      </Typography>
      <ModalPricingVolumeAndProductOptionSelector modalCard={modalCard} />
      {modalCard.recommendationText && (
        <Highlight className="cur-mt-4" state="success">
          <div
            dangerouslySetInnerHTML={{
              __html: modalCard.recommendationText.modalCallout,
            }}
          ></div>
        </Highlight>
      )}
      <ModalRatingAndNumReviews modalCard={modalCard} />
      <Typography className="cur-mt-4" size="h3">
        Why it&apos;s special
      </Typography>
      <Typography className="cur-mt-4">
        Sudden spot? We&apos;ve got emergencies covered with this patch
        that&apos;s so low-profile, you can wear it out and about during the
        day. Thin enough to layer under makeup, this hydrocolloid absorbs pus
        and oil without using active ingredients that might irritate your skin.
      </Typography>
      <Typography className="cur-mt-4">
        Just peel the patch off 6-24 hours later, and go forth. You can repeat
        as needed.
      </Typography>
      <Typography className="cur-mt-4">
        Our spot patch is great for emergencies, but for long-term treatment,
        rely on your custom formula to meet your skin goals.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        Ingredients
      </Typography>
      <Typography className="cur-mt-4">
        Copolymer, Resin, Mineral Oil, Carboxymethylcellulose (CMC), Hindered
        Phenolic Antioxidant
      </Typography>
      <ul className="cur-list-disc cur-ml-4">
        <li className="cur-mt-4">
          <Typography>
            Mineral oil is used as a processing aid, and is added in small
            quantities in the coating process.
          </Typography>
        </li>
        <li className="cur-mt-4">
          <Typography>
            Resin is made from wood rosin (colophony), which comes from pines
            and other plants.
          </Typography>
        </li>
        <li className="cur-mt-4">
          <Typography>
            Spot patches may not be a good choice for you if you are allergic to
            adhesive products, including bandages.
          </Typography>
        </li>
      </ul>
    </>
  );
};
